import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React from 'react';
import DisplayData from 'shared/display-data/display-data.component';
import {
  ADDITIONAL_RECEIVERS_BUTTON_ID,
  ADDITIONAL_RECEIVERS_LABEL_TEXT
} from './additional-receivers.constants';

export default function AdditionalReceivers({
  onClick,
  receiversData,
  hasDivider
}) {
  const buttonIcon = receiversData ? icons.type.EDIT : icons.type.ADD;

  return (
    <DisplayData
      hasDivider={hasDivider}
      label={ADDITIONAL_RECEIVERS_LABEL_TEXT}
      mainData={receiversData}
      icon={icons.type.USER}
      actionButton={{
        icon: buttonIcon,
        click: onClick,
        dataTestid: ADDITIONAL_RECEIVERS_BUTTON_ID
      }}
    />
  );
}

AdditionalReceivers.displayName = 'AdditionalReceivers';
AdditionalReceivers.propTypes = {
  onClick: PropTypes.func.isRequired,
  receiversData: PropTypes.string,
  hasDivider: PropTypes.bool
};
AdditionalReceivers.defaultProps = {
  receiversData: null,
  hasDivider: false
};
